import createRoutine from '@/utils/createRoutine'

export const xeroOnboardingRoutine = createRoutine('xeroOnboardingRoutine')
export const xeroAuthRoutine = createRoutine('xeroAuthRoutine')
export const xeroOriginRoutine = createRoutine('xeroOriginRoutine')
export const xeroIsXeroLoginRoutine = createRoutine('xeroIsXeroLoginRoutine')

export const xeroGetters = {
  VALIDATION_STATE_CODE: 'VALIDATION_STATE_CODE',
  XERO_ORIGIN: 'XERO_ORIGIN',
  ONBOARDING_DATA: 'ONBOARDING_DATA',
  IS_XERO_LOGIN: 'IS_XERO_LOGIN'
}
